import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { Box, styled, Button as MuiButton, Collapse, Typography } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { CallActionBox } from './call-styles';
import { formatUSPhoneNumber } from '../../utils/formatter';
import { useLwp } from '../../hooks/use-lwp';

const ExpandButton = styled(MuiButton)({
  fontSize: 24,
  padding: '14px 0 6px'
});

const ContactInfo = styled(Box)({
  marginTop: 24,
  marginBottom: 48,
  color: '#FFF'
});

const ContactName = styled(Typography)({
  textAlign: 'center',
  textTransform: 'uppercase',
  fontSize: 14,
  fontWeight: 500
});

const ContactPhoneNumber = styled(Typography)({
  marginTop: 8,
  textAlign: 'center',
  fontSize: 24,
  fontWeight: 400
});

function CallWarningActions(props: { phoneNumber: string | undefined }) {
  const { phoneState: { contactName } } = useLwp();
  const [showActions, setShowActions] = useState<boolean>(false);
  const formattedPhoneNumber = useMemo(() => formatUSPhoneNumber(props.phoneNumber), [props.phoneNumber]);

  const toggleActions = useCallback(() => {
    setShowActions((show) => (show ? false : true));
  }, []);

  return (
    <div data-testid="call-warning-action-container-div">
      <ExpandButton fullWidth onClick={toggleActions}>
        {!showActions ? <ExpandMore /> : <ExpandLess />}
      </ExpandButton>
      <Collapse in={showActions}>
        <CallActionBox>
          <ContactInfo>
            {contactName && (
              <ContactName>
                {contactName}
              </ContactName>
            )}
            <ContactPhoneNumber>{formattedPhoneNumber}</ContactPhoneNumber>
          </ContactInfo>
        </CallActionBox>
      </Collapse>
    </div>
  );
}

export default memo(CallWarningActions);
